"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormularioGrid = void 0;
var estiloFormularioGrid = require('./FormularioGrid.module.scss');
var react_1 = __importDefault(require("react"));
var FormularioGrid = function (_a) {
    var _b = _a.tipo, tipo = _b === void 0 ? "container" : _b, id = _a.id, _c = _a.width, width = _c === void 0 ? 100 : _c, _d = _a.height, height = _d === void 0 ? "100%" : _d, minHeight = _a.minHeight, children = _a.children, _e = _a.className, className = _e === void 0 ? "" : _e, style = _a.style;
    var styleSheet = {};
    if ("container" === tipo)
        className += "".concat(estiloFormularioGrid.formularioGridContainer);
    else if ("row" === tipo) {
        className += "".concat(estiloFormularioGrid.formularioGridRow);
    }
    else if ("column" === tipo) {
        var cssLargura = estiloFormularioGrid["width".concat(width)];
        className += "".concat(estiloFormularioGrid.formularioGridColumn, " ").concat(cssLargura);
    }
    return (react_1.default.createElement("div", { style: __assign(__assign({}, style), { height: height, minHeight: minHeight }), id: id, className: className }, children));
};
exports.FormularioGrid = FormularioGrid;
